/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Core_Select_An_OptionInputs */

const en_core_select_an_option = /** @type {(inputs: Core_Select_An_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an option`)
};

/**
* | output |
* | --- |
* | "Select an option" |
*
* @param {Core_Select_An_OptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const core_select_an_option = /** @type {((inputs?: Core_Select_An_OptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Core_Select_An_OptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_core_select_an_option(inputs)
});